import { render, staticRenderFns } from "./Kirin.vue?vue&type=template&id=4c09fcd5&"
import script from "./Kirin.vue?vue&type=script&lang=js&"
export * from "./Kirin.vue?vue&type=script&lang=js&"
import style0 from "./Kirin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports